import React, { Component } from 'react'
import {
    Badge,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Dropdown
} from 'reactstrap';
import _ from 'lodash'

class CommonDropdown extends Component{
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
            filter: null
        };
        this.status = [
            {
                title: "Enviado a laboratorio",
                color: "status-text",
                code: 0
            },
            {
                title: "En estudio",
                color: "status-text-0",
                code: 1
            },
            {
                title: "Esperando aprobación",
                color: "status-text-1",
                code: 2
            },
            {
                title: "Aprobado",
                color: "status-text-2",
                code: 3
            },
            {
                title: "Iniciada producción",
                color: "status-text-3",
                code: 4
            },
            {
                title: "Entregado parcial",
                color: "status-text-4",
                code: 5
            },
            {
                title: "Entregado",
                color: "status-text-5",
                code: 6
            },
            {
                title: "No aceptado",
                color: null,
                code: 8
            }
        ]
    }
    doFilter(e){
        let filter = e.target.id
        this.setState({ filter })
        this.props.applyFilter(filter)
    }
    removeFilter(){
        let filter = null
        this.setState({ filter })
        this.props.applyFilter(filter)
    }
    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }
    render(){
        if(this.state.filter){
            const filterObject = _.find(this.status, {code: Number(this.state.filter)})
            return (
                <button
                    type="button"
                    className="btn btn-outline-secondary float-right"
                    onClick={this.removeFilter.bind(this)}
                >
                    <i className="fa fa-close " /> &nbsp;Quitar filtro por estado: <span className={filterObject.color}> {filterObject.title}</span>
                </button>)
        }else{
            return (
                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle.bind(this)} className="float-right">
                    <DropdownToggle className="btn-outline-secondary">
                        <span className="d-md-down-none">Filtrar por estado <i className="fa fa-caret-down" /> </span>
                    </DropdownToggle>
                    <DropdownMenu>
                        {this.status.map((stat) => {
                            return (
                                <DropdownItem
                                    onClick={this.doFilter.bind(this)}
                                    id={stat.code}
                                    key={stat.code}>
                                    <i className={"fa fa-circle " + stat.color} />
                                    {stat.title}
                                </DropdownItem>
                            );
                        })}
                    </DropdownMenu>
                </Dropdown>
            );
        }
    }
}
export default CommonDropdown


// WEBPACK FOOTER //
// ./resources/assets/js/components/casos/FilterDropdown.jsx